// extracted by mini-css-extract-plugin
export default {"actionOptionsContainer":"style_actionOptionsContainer__z45dl","option":"style_option__PEpPW","optionIcon":"style_optionIcon__mKrzb","optionText":"style_optionText__8axMc"};